import React from "react";
import { Card, Button, Form, Row, Col } from "react-bootstrap";
import moment from "moment";
import { RESERVATION_COLOR } from "../../constants";
import { generateBookingSlots } from "./utils";

class DiningServiceGroupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: this.props.group || {
        name: "",
        active: true,
        service_name: "",
        start_time: "",
        end_time: "",
        interval: 60,
        experiences: [],
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.group !== prevProps.group) {
      this.setState({
        formData: this.props.group || { name: "", active: true },
      });
    }
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };

  handleExperienceChange = (experienceId) => {
    const experienceObject = this.props.experiences.find(
      (exp) => exp._id === experienceId,
    );
    if (!experienceObject) return;

    this.setState((prevState) => {
      const { experiences = [] } = prevState.formData;
      const newExperiences = [...experiences];
      const index = newExperiences.findIndex((exp) => exp._id === experienceId);

      if (index > -1) {
        newExperiences.splice(index, 1);
      } else {
        newExperiences.push(experienceObject);
      }

      return {
        formData: { ...prevState.formData, experiences: newExperiences },
      };
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSave(this.state.formData);
  };

  render() {
    return (
      <Card
        className="mt-5 mb-8 border-0 shadow-sm overflow-hidden"
        style={{ borderRadius: "12px" }}
      >
        <Card.Header
          className="bg-light border-0 py-6"
          style={{ borderBottom: "1px dashed #ebedf3 !important" }}
        >
          <div className="d-flex align-items-center">
            <span
              className="btn btn-icon btn-light-info mr-4 no-hover"
              style={{ cursor: "default" }}
            >
              <i className="fas fa-layer-group text-info"></i>
            </span>
            <h3 className="text-dark font-weight-boldest m-0">
              {this.props.group
                ? "Edit Group Details"
                : "Create New Service Group"}
            </h3>
          </div>
        </Card.Header>
        <Card.Body className="p-8">
          <Form onSubmit={this.handleSubmit}>
            <Form.Group className="mb-8">
              <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                Group Name
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                className="form-control-solid"
                placeholder="E.g., Weekday Lunch, Weekend Special"
                value={this.state.formData.name}
                onChange={this.handleChange}
                required
              />
              <Form.Text className="text-muted mt-2">
                This groups related dining slots together for easier management.
              </Form.Text>
            </Form.Group>

            {!this.props.group && (
              <div className="bg-light-o-5 p-8 rounded-xl border border-light">
                <div className="d-flex align-items-center mb-6">
                  <i
                    className="fas fa-plus-circle text-info mr-3"
                    style={{ fontSize: "1.2rem" }}
                  ></i>
                  <h5 className="mb-0 font-weight-boldest text-dark">
                    Configure Initial Dining Slot
                  </h5>
                </div>

                <Form.Group className="mb-6">
                  <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                    Slot Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="service_name"
                    className="form-control-solid"
                    placeholder="e.g., Brunch Service"
                    value={this.state.formData.service_name}
                    onChange={this.handleChange}
                    required
                  />
                </Form.Group>

                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-6">
                      <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                        Start Time
                      </Form.Label>
                      <Form.Control
                        type="time"
                        name="start_time"
                        className="form-control-solid"
                        value={this.state.formData.start_time}
                        onChange={this.handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-6">
                      <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                        End Time
                      </Form.Label>
                      <Form.Control
                        type="time"
                        name="end_time"
                        className="form-control-solid"
                        value={this.state.formData.end_time}
                        onChange={this.handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-6">
                      <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                        Duration (min)
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="interval"
                        className="form-control-solid"
                        placeholder="e.g. 60"
                        value={this.state.formData.interval}
                        onChange={this.handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {this.state.formData.start_time &&
                  this.state.formData.end_time &&
                  this.state.formData.interval > 0 && (
                    <div className="mb-8 p-6 bg-white rounded shadow-xs border">
                      <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-3 d-block">
                        Booking Slots Preview
                      </Form.Label>
                      <div
                        className="d-flex flex-wrap"
                        style={{ maxHeight: "120px", overflowY: "auto" }}
                      >
                        {generateBookingSlots(
                          this.state.formData.start_time,
                          this.state.formData.end_time,
                          this.state.formData.interval,
                        ).map((slot, index) => (
                          <span
                            key={index}
                            className="badge badge-light font-weight-bold mr-2 mb-2 px-3 py-2"
                            style={{ fontSize: "0.75rem" }}
                          >
                            {slot}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                {this.props.experiences.length > 0 && (
                  <div className="experience-selection-area">
                    <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-4 d-block">
                      Link Experiences
                    </Form.Label>
                    <div className="row">
                      {this.props.experiences.map((experience) => {
                        const isChecked = (
                          this.state.formData.experiences || []
                        ).some((exp) => exp._id === experience._id);
                        return (
                          <div
                            key={`experience-checkbox-${experience._id}`}
                            className="col-md-6 mb-3"
                          >
                            <div
                              className={`p-4 rounded-xl border d-flex align-items-center cursor-pointer transition-all ${
                                isChecked
                                  ? "border-info bg-light-info shadow-xs"
                                  : "border-light bg-hover-light"
                              }`}
                              style={{ transition: "0.2s ease" }}
                              onClick={() =>
                                this.handleExperienceChange(experience._id)
                              }
                            >
                              <span className="switch switch-sm switch-icon switch-info mr-4">
                                <label className="m-0">
                                  <input
                                    onClick={() =>
                                      this.handleExperienceChange(
                                        experience._id,
                                      )
                                    }
                                    type="checkbox"
                                    checked={isChecked}
                                  />
                                  <span></span>
                                </label>
                              </span>
                              <span
                                className={`font-weight-boldest ${
                                  isChecked ? "text-info" : "text-dark-75"
                                }`}
                              >
                                {experience.name}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}

            <div className="d-flex justify-content-end border-top pt-8 mt-8">
              <Button
                variant="light"
                className="btn btn-light-info font-weight-boldest px-8 mr-4"
                onClick={this.props.onCancel}
              >
                CANCEL
              </Button>
              <Button
                type="submit"
                className="btn btn-info font-weight-boldest px-8 shadow-sm"
                style={{ backgroundColor: RESERVATION_COLOR }}
              >
                SAVE GROUP
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    );
  }
}

export default class DiningServiceManager extends React.Component {
  render() {
    const {
      diningServices,
      isFormVisible,
      editingDiningService,
      onAddNewClick,
      onEdit,
      onDelete,
      onSave,
      onCancel,
      experiences,
      diningServiceGroups,
      isDiningServiceGroupFormVisible,
      editingDiningServiceGroup,
      onGroupCancel,
      onGroupSave,
      editingGroupId,
      setEditingGroupId,
      addingToGroupId,
      setAddingToGroupId,
      onGroupNameChange,
      onGroupNameBlur,
      onGroupDelete,
    } = this.props;

    return (
      <div className="d-flex flex-column mt-4">
        {isDiningServiceGroupFormVisible && (
          <DiningServiceGroupForm
            group={editingDiningServiceGroup}
            onSave={onGroupSave}
            experiences={experiences}
            onCancel={onGroupCancel}
          />
        )}

        {[...diningServiceGroups]
          .sort((a, b) => {
            const getMinStartTime = (groupId) => {
              const groupServices = diningServices.filter(
                (s) => s.dining_service_group === groupId,
              );
              if (groupServices.length === 0) return "99:99";
              return groupServices.reduce(
                (min, s) => (s.start_time < min ? s.start_time : min),
                groupServices[0].start_time,
              );
            };
            return getMinStartTime(a._id).localeCompare(getMinStartTime(b._id));
          })
          .map((group) => (
            <div key={group._id} className="mb-10">
              {/* GROUP HEADER */}
              <div
                className="d-flex justify-content-between align-items-center mb-6 pl-2"
                style={{ borderLeft: `4px solid ${RESERVATION_COLOR}` }}
              >
                <div className="d-flex align-items-center flex-grow-1 pl-4">
                  {editingGroupId === group._id ? (
                    <div className="d-flex align-items-center w-100 mr-10">
                      <Form.Control
                        type="text"
                        className="form-control-solid font-weight-boldest font-size-h4 h-auto py-2"
                        value={group.name}
                        onChange={(e) => onGroupNameChange(e, group._id)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            onGroupNameBlur(group);
                            setEditingGroupId(null);
                          }
                        }}
                        autoFocus
                      />
                      <div className="d-flex ml-4">
                        <Button
                          variant="link"
                          className="btn btn-icon btn-light-success btn-sm p-0 mr-2 shadow-xs"
                          onClick={() => {
                            onGroupNameBlur(group);
                            setEditingGroupId(null);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: RESERVATION_COLOR }}
                          />
                        </Button>
                        <Button
                          variant="link"
                          className="btn btn-icon btn-light-danger btn-sm p-0 shadow-xs"
                          onClick={() => setEditingGroupId(null)}
                        >
                          <i className="fas fa-times" />
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <h3 className="text-dark-75 font-weight-boldest mb-0 mr-4">
                        {group.name}
                      </h3>
                      <span
                        className="badge badge-pill badge-light-info font-weight-boldest font-size-xs px-3 py-2 text-uppercase"
                        style={{ letterSpacing: "0.5px" }}
                      >
                        {(() => {
                          const servicesInGroup = diningServices.filter(
                            (s) => s.dining_service_group === group._id,
                          );
                          let totalSlots = 0;
                          servicesInGroup.forEach((s) => {
                            totalSlots += generateBookingSlots(
                              s.start_time,
                              s.end_time,
                              s.interval,
                            ).length;
                          });
                          return totalSlots;
                        })()}{" "}
                        Slots
                      </span>
                    </div>
                  )}
                </div>

                {!editingGroupId && (
                  <div className="d-flex align-items-center">
                    <Button
                      variant="link"
                      className="btn btn-icon btn-light-info btn-sm mr-2 shadow-xs"
                      onClick={() => setEditingGroupId(group._id)}
                    >
                      <i
                        className="far fa-edit text-info font-size-h6"
                        style={{ color: RESERVATION_COLOR }}
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="btn btn-icon btn-light-danger btn-sm shadow-xs"
                      onClick={() => onGroupDelete(group._id)}
                    >
                      <i className="far fa-trash-alt text-danger font-size-h6" />
                    </Button>
                  </div>
                )}
              </div>

              {/* SLOTS LIST */}
              <div className="pl-4">
                {diningServices
                  .filter(
                    (service) => service.dining_service_group === group._id,
                  )
                  .sort((a, b) => a.start_time.localeCompare(b.start_time))
                  .map((service) =>
                    editingDiningService?._id === service._id ? (
                      <DiningServiceForm
                        key={service._id}
                        diningServices={diningServices}
                        experiences={experiences}
                        diningService={editingDiningService}
                        onSave={onSave}
                        onCancel={onCancel}
                        diningServiceGroups={diningServiceGroups}
                      />
                    ) : (
                      <Card
                        key={service._id}
                        className="mb-5 shadow-sm border-0"
                        style={{ borderRadius: "12px", overflow: "hidden" }}
                      >
                        {(() => {
                          const bookingSlots = generateBookingSlots(
                            service.start_time,
                            service.end_time,
                            service.interval,
                          );
                          return (
                            <Card.Body className="p-0">
                              <div className="d-flex align-items-stretch">
                                {/* Time Side Block */}
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center p-6 bg-light text-center"
                                  style={{
                                    minWidth: "160px",
                                    borderRight: "1px dashed #ebedf3",
                                  }}
                                >
                                  <span
                                    className="text-muted font-weight-boldest font-size-xs mb-2 text-uppercase"
                                    style={{ letterSpacing: "0.5px" }}
                                  >
                                    Service Time
                                  </span>
                                  <div className="d-flex align-items-center mb-1">
                                    <i
                                      className="far fa-clock mr-2 text-info"
                                      style={{ color: RESERVATION_COLOR }}
                                    />
                                    <span className="text-dark font-weight-boldest font-size-h5">
                                      {moment(
                                        service.start_time,
                                        "HH:mm",
                                      ).format("h:mm A")}
                                    </span>
                                  </div>
                                  <div className="text-muted font-weight-boldest font-size-xs mb-3">
                                    UNTIL{" "}
                                    {moment(service.end_time, "HH:mm").format(
                                      "h:mm A",
                                    )}
                                  </div>
                                  <span className="badge badge-light-o-70 font-weight-boldest font-size-xs px-3 py-1">
                                    {service.interval} MIN
                                  </span>
                                </div>

                                {/* Main Content Area */}
                                <div className="flex-grow-1 p-6">
                                  <div className="d-flex flex-column h-100">
                                    <h4 className="text-dark font-weight-boldest mb-3">
                                      {service.name}
                                    </h4>
                                    <div className="d-flex flex-wrap mb-4">
                                      {service.experiences.map((experience) =>
                                        experience ? (
                                          <span
                                            key={experience._id}
                                            className="badge badge-pill badge-primary font-weight-boldest font-size-xs mr-2 mb-2 px-3 py-2"
                                            style={{
                                              backgroundColor:
                                                RESERVATION_COLOR,
                                            }}
                                          >
                                            {experience.name}
                                          </span>
                                        ) : null,
                                      )}
                                    </div>

                                    {bookingSlots.length > 0 && (
                                      <div className="mt-auto">
                                        <div className="d-flex flex-wrap">
                                          {bookingSlots.map((slot, index) => (
                                            <span
                                              key={index}
                                              className="badge badge-light font-weight-boldest mr-2 mb-2 px-3 py-2"
                                              style={{
                                                fontSize: "0.85rem",
                                                opacity: 0.9,
                                              }}
                                            >
                                              {slot}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Actions Side Bar */}
                                <div className="d-flex flex-column justify-content-center px-4 border-left bg-light-o-5">
                                  <Button
                                    variant="link"
                                    className="btn btn-icon btn-light-info btn-sm mb-2 shadow-xs"
                                    onClick={() => onEdit(service)}
                                  >
                                    <i
                                      className="far fa-edit text-info font-size-h6"
                                      style={{ color: RESERVATION_COLOR }}
                                    />
                                  </Button>
                                  <Button
                                    variant="link"
                                    className="btn btn-icon btn-light-danger btn-sm shadow-xs"
                                    onClick={() => onDelete(service._id)}
                                  >
                                    <i className="far fa-trash-alt text-danger font-size-h6" />
                                  </Button>
                                </div>
                              </div>
                            </Card.Body>
                          );
                        })()}
                      </Card>
                    ),
                  )}

                {/* Add Slot Button within Group */}
                {isFormVisible && addingToGroupId === group._id ? (
                  <DiningServiceForm
                    diningServices={diningServices}
                    experiences={experiences}
                    diningService={editingDiningService}
                    onSave={onSave}
                    onCancel={onCancel}
                    diningServiceGroups={diningServiceGroups}
                    preselectedGroup={group._id}
                  />
                ) : (
                  !isFormVisible &&
                  !editingGroupId &&
                  !editingDiningService && (
                    <Button
                      variant="outline-info"
                      className="w-100 p-8 d-flex flex-column align-items-center justify-content-center mt-2"
                      onClick={() => {
                        setAddingToGroupId(group._id);
                        onAddNewClick();
                      }}
                      style={{
                        border: `2px dashed ${RESERVATION_COLOR}`,
                        backgroundColor: "rgba(137, 80, 252, 0.03)",
                        borderRadius: "12px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i
                        className="fas fa-plus-circle mb-3"
                        style={{ fontSize: "2rem", color: RESERVATION_COLOR }}
                      />
                      <span
                        className="font-weight-boldest text-uppercase"
                        style={{
                          color: RESERVATION_COLOR,
                          letterSpacing: "1.5px",
                          fontSize: "0.85rem",
                        }}
                      >
                        Add Dining Slot to {group.name}
                      </span>
                    </Button>
                  )
                )}
              </div>
            </div>
          ))}
      </div>
    );
  }
}

class DiningServiceForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: this.props.diningService || {
        name: "",
        start_time: "",
        end_time: "",
        interval: "",
        experiences: [],
        dining_service_group: this.props.preselectedGroup || "",
      },
      errors: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.diningService !== prevProps.diningService) {
      this.setState({
        formData: this.props.diningService || {
          name: "",
          start_time: "",
          end_time: "",
          interval: "",
          experiences: [],
          dining_service_group: this.props.preselectedGroup || "",
        },
        errors: {},
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const newFormData = { ...prevState.formData, [name]: value };
      const newErrors = { ...prevState.errors };

      const { start_time, end_time, interval } = newFormData;

      if (start_time && end_time) {
        const currentStart = moment(start_time, "HH:mm");
        const currentEnd = moment(end_time, "HH:mm");

        if (currentEnd.isSameOrBefore(currentStart)) {
          newErrors.time = "The end time should be later than the start time.";
        } else {
          const { diningServices, diningService } = this.props;

          const otherServices = diningServices.filter(
            (service) => !diningService || service._id !== diningService._id,
          );

          const isOverlapping = otherServices.some((service) => {
            const existingStart = moment(service.start_time, "HH:mm");
            const existingEnd = moment(service.end_time, "HH:mm");

            return (
              currentStart.isBefore(existingEnd) &&
              currentEnd.isAfter(existingStart)
            );
          });

          if (isOverlapping) {
            newErrors.time =
              "This time slot overlaps with another slot/service.";
          } else {
            delete newErrors.time;
          }
        }
      } else {
        delete newErrors.time;
      }

      if (interval && (interval < 15 || interval > 360)) {
        newErrors.interval =
          "Slot duration must be between 15 and 360 minutes.";
      } else {
        delete newErrors.interval;
      }

      return {
        formData: newFormData,
        errors: newErrors,
      };
    });
  };

  handleExperienceChange = (experienceId) => {
    const experienceObject = this.props.experiences.find(
      (exp) => exp._id === experienceId,
    );
    if (!experienceObject) return;

    this.setState((prevState) => {
      const { experiences = [] } = prevState.formData;
      const newExperiences = [...experiences];
      const index = newExperiences.findIndex((exp) => exp._id === experienceId);

      if (index > -1) {
        newExperiences.splice(index, 1);
      } else {
        newExperiences.push(experienceObject);
      }

      return {
        formData: { ...prevState.formData, experiences: newExperiences },
      };
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSave(this.state.formData);
  };

  render() {
    const { errors, formData } = this.state;

    return (
      <Card
        className="mt-5 mb-8 border-info shadow-sm overflow-hidden"
        style={{
          borderRadius: "12px",
          borderStyle: "dashed",
          borderWidth: "2px",
        }}
      >
        <Card.Body className="p-8">
          <div className="d-flex align-items-center mb-8">
            <span
              className="btn btn-icon btn-light-info mr-4 no-hover"
              style={{ cursor: "default" }}
            >
              <i className="fas fa-plus text-info"></i>
            </span>
            <h3 className="text-dark font-weight-boldest m-0">
              {this.props.diningService
                ? "Edit Dining Slot"
                : "Add New Dining Slot"}
            </h3>
          </div>

          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col md={8}>
                <Form.Group className="mb-6">
                  <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                    Slot Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    className="form-control-solid"
                    placeholder="e.g. Regular Lunch, Event Service"
                    value={this.state.formData.name}
                    onChange={this.handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-6">
                  <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                    Target Group
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="dining_service_group"
                    className="form-control-solid"
                    value={this.state.formData.dining_service_group}
                    onChange={this.handleChange}
                    disabled={true}
                  >
                    {this.props.diningServiceGroups.map((group) => (
                      <option key={group._id} value={group._id}>
                        {group.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="bg-light-o-5 p-8 rounded-xl mb-8">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                      Start Time
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="start_time"
                      className="form-control-solid"
                      value={this.state.formData.start_time}
                      onChange={this.handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                      End Time
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="end_time"
                      className="form-control-solid"
                      value={this.state.formData.end_time}
                      onChange={this.handleChange}
                      required
                      isInvalid={!!errors.time}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.time}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-2">
                      Duration (min)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="interval"
                      className="form-control-solid"
                      placeholder="e.g. 30"
                      value={formData.interval}
                      onChange={this.handleChange}
                      required
                      isInvalid={!!errors.interval}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.interval}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {formData.start_time &&
              formData.end_time &&
              formData.interval > 0 &&
              !errors.time && (
                <div className="mb-8 p-6 bg-white rounded shadow-xs border">
                  <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-3 d-block">
                    Booking Slots Preview
                  </Form.Label>
                  <div
                    className="d-flex flex-wrap"
                    style={{ maxHeight: "120px", overflowY: "auto" }}
                  >
                    {generateBookingSlots(
                      formData.start_time,
                      formData.end_time,
                      formData.interval,
                    ).map((slot, index) => (
                      <span
                        key={index}
                        className="badge badge-light-o-80 font-weight-bold mr-2 mb-2 px-4 py-2"
                      >
                        {slot}
                      </span>
                    ))}
                  </div>
                </div>
              )}

            {this.props.experiences.length > 0 && (
              <div className="experience-selection-area">
                <Form.Label className="font-weight-boldest text-uppercase font-size-xs text-muted mb-4 d-block">
                  Linked Experiences
                </Form.Label>
                <div className="row">
                  {this.props.experiences.map((experience) => {
                    const isChecked = (
                      this.state.formData.experiences || []
                    ).some((exp) => exp._id === experience._id);

                    return (
                      <div
                        key={`experience-${experience._id}`}
                        className="col-md-6 mb-3"
                      >
                        <div
                          className={`p-4 rounded-xl border d-flex align-items-center cursor-pointer transition-all ${
                            isChecked
                              ? "border-info bg-light-purple shadow-xs" // Checked: Purple BG & Border
                              : "border-secondary bg-gray-200" // Unchecked: Gray BG & Border
                          }`}
                          onClick={() =>
                            this.handleExperienceChange(experience._id)
                          }
                        >
                          <span
                            className={`switch switch-sm switch-icon mr-4 ${
                              isChecked ? "switch-success" : "switch-danger"
                            }`}
                          >
                            <label className="m-0">
                              <input
                                onClick={() =>
                                  this.handleExperienceChange(experience._id)
                                }
                                type="checkbox"
                                checked={isChecked}
                              />
                              <span></span>
                            </label>
                          </span>

                          {/* Text matches the Purple theme when checked */}
                          <span
                            className={`font-weight-boldest ${
                              isChecked ? "text-purple" : "text-dark-75"
                            }`}
                          >
                            {experience.name}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="d-flex justify-content-end border-top pt-8 mt-8">
              <Button
                variant="light"
                className="btn btn-light-info font-weight-boldest px-10 mr-4"
                onClick={this.props.onCancel}
              >
                CANCEL
              </Button>
              <Button
                type="submit"
                className="btn btn-info font-weight-boldest px-10 shadow-sm"
                style={{ backgroundColor: RESERVATION_COLOR }}
                disabled={errors.time || errors.interval}
              >
                SAVE SLOT
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
